export const BROWSER_LIST = {
    isIE: !!window.navigator.userAgent.match(/(MSIE|Trident)/),
};
